"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_instantsearch_dom_1 = require("react-instantsearch-dom");
var Button_1 = __importDefault(require("../../atoms/Button/Button"));
var react_redux_1 = require("react-redux");
var ExportBtn = function (_a) {
    var searchState = _a.searchState;
    var columnFilters = react_redux_1.useSelector(function (state) { return state.filters.chosenColumnFilters; });
    var handleClick = function () {
        var returnValue = confirm("Weet je zeker dat je het aanbod wil exporteren?");
        if (returnValue) {
            getExport({ excluded_columns: columnFilters, searchstate: searchState });
        }
        else {
            return;
        }
    };
    function s2ab(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i)
            view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }
    var getExport = function (data) {
        // const paramsAsString = toQuery(data);
        var url = "/api/export/?excluded_columns=" + encodeURIComponent(JSON.stringify(data.excluded_columns)) + "&searchstate=" + encodeURIComponent(JSON.stringify(data.searchstate));
        var link = document.createElement('a');
        link.href = url;
        document.body.append(link);
        link.click();
    };
    var date = function () {
        var now = new Date();
        var day = now.toISOString().slice(0, 10);
        var time = now.getHours() + "-" + ((now.getMinutes() < 10 ? '0' : '') + now.getMinutes());
        return day + "_" + time;
    };
    return (react_1.default.createElement(Button_1.default, { onClick: handleClick },
        react_1.default.createElement("span", null, "Export naar excel")));
};
var AGExportBtn = react_instantsearch_dom_1.connectStateResults(ExportBtn);
exports.default = AGExportBtn;
